import { Box, Stack, TextField, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import React from "react";

export default function TextFieldCustom(params) {
  return (
    <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-end"} spacing={2}>
      <Typography align="left" variant="subtitle1" fontWeight={"bold"}>
        {params.required ? "*" + params.title :params.title  }
      </Typography>
      <TextField
        InputProps={{ inputProps: { min: params.min, max: params.max } }}
        disabled={params.disabled || false}
        required={params.required}
        multiline={params.multiline || false}
        rows={params.multiline ? 5 : 1}
        variant="outlined"
        name={params.name}
        id={params.id}
        value={params.value || ""}
        onChange={params.onChange}
        type={params.type || "text"}
        label={params.value ? "" : params.label}
        slotProps={{ inputLabel: { shrink: false } }}
        sx={{
          width: "90%",
          "& .MuiInputBase-input": {
            padding: params.multiline ? 0 : 1,
            // fontWeight: "bold",
          },
          "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
            transform: params.multiline
              ? "translate(10px, 17px) scale(1)"
              : "translate(10px, 8px) scale(1)",
          },
          "& .MuiInputLabel-root": {
            // color: "green",
          },
          "& .MuiFormLabel-asterisk": {
            display: "none",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "green",
              borderRadius: 2,
            },
            "&:hover fieldset": {
              borderColor: red[500],
            },
            "&.Mui-focused fieldset": {
              borderColor: red[500],
            },
          },
        }}
      />
    </Stack>
  );
}
